import { openModal } from '@core/components/ModalStack';
import { AddEditServiceProviderModalProps } from './AddEditServiceProvider';

export async function openAddEditServiceProviderModal(props: AddEditServiceProviderModalProps) {
  const { AddEditServiceProvider } = await import('./AddEditServiceProvider');

  openModal(AddEditServiceProvider, props);
}
